<template>
  <b-form @submit.prevent="submit">
    <b-row>
      <b-col cols="12">
        <template v-if="poolSelectionVisible">
          <b-form-group
            id="input-pools"
            label="Pools"
            label-for="input-pool"
            class="mb-2"
          >
            <b-row>
              <b-col cols="9">
                <b-form-select
                  v-if="poolOptions.length > 0"
                  v-model="selectedPool"
                  v-validate="{ required: false }"
                  :options="poolOptions"
                  data-vv-name="pools"
                  size="lg"
                ></b-form-select>
              </b-col>
              <b-col>
                <b-btn
                  size="lg"
                  variant="outline-secondary"
                  type="submit"
                  block
                  :disabled="!selectedPool || form.pools.length === 2"
                  @click.prevent="addPool"
                >
                  <i class="fa fa-plus" /> Add
                </b-btn>
              </b-col>
            </b-row>
          </b-form-group>
          <table class="table table-hover vertical-align-middle border-bottom mb-4">
            <tbody>
              <tr v-for="(pool, i) in form.pools" :key="i" class="query">
                <td>
                  {{ poolsByDateDesc.find(p => p._id === pool.pool_id).name }}
                </td>
                <td class="text-right">
                  <b-btn-group>
                    <b-btn variant="outline-secondary" size="sm" @click="removePool(i)">
                      <i class="fa fa-trash" />
                    </b-btn>
                  </b-btn-group>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group
          id="input-name"
          label="Name"
          label-for="input-name"
          class="mb-4"
        >
          <b-form-input
            id="input-name"
            v-model.trim="form.name"
            v-validate="{ required: true, max: 100 }"
            type="text"
            placeholder="Name"
            size="lg"
            data-vv-name="name"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col cols="6">
        <b-form-group
          id="input-description"
          label="Description"
          label-for="input-description"
          class="mb-4"
        >
          <b-form-input
            id="input-description"
            v-model.number="form.description"
            v-validate="{ required: false, max: 500 }"
            type="text"
            placeholder="Description"
            size="lg"
            data-vv-name="description"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col class="text-right" cols="12">
          <div class="form-footer">
            <b-row>
              <b-col cols="6" class="mt-2 text-left">  
                <b-form-checkbox
                  id="configOptions"
                  name="configOptions"
                  v-model="form.configOptions"
                >Show Configuration</b-form-checkbox>
              </b-col>
              <b-col cols="6">
                <b-btn variant="primary" size="lg" type="submit" v-if="!form.configOptions">
                  <i class="fa fa-plus" /> Save
                </b-btn>
              </b-col>
            </b-row>
          </div>
      </b-col>
    </b-row>
    <b-row v-if="form.configOptions" class="mt-4">
            <b-col cols="4">
              <b-form-group
                id="input-group-lower-limit"
                label="Lower limit"
                label-for="input-lower-limit"
                class="mb-4"
              >
                <b-form-input
                  id="input-lower-limit"
                  v-model="configForm.lowerLimit"
                  v-validate="{ numeric: true, min_value: 2 }"
                  placeholder="Default: 4"
                  data-vv-name="lower limit"
                  number
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <b-form-group
                id="input-group-upper-limit"
                label="Upper limit"
                label-for="input-upper-limit"
                class="mb-4"
              >
                <b-form-input
                  id="input-upper-limit"
                  v-model="configForm.upperLimit"
                  v-validate="{ numeric: true }"
                  placeholder="Default: none"
                  data-vv-name="upper limit"
                  number
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <b-form-group
                id="input-group-ratio"
                label="Ratio"
                label-for="input-ratio"
                class="mb-4"
              >
                <b-form-input
                  id="input-ratio"
                  v-model="configForm.ratio"
                  v-validate="{ decimal: 1, min_value: 1 }"
                  type="text"
                  placeholder="Default: 1.1"
                  data-vv-name="ratio"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <b-form-group
                id="input-group-max-word-count"
                label="Max word count"
                label-for="input-max-word-count"
                class="mb-4"
              >
                <b-form-input
                  id="input-max-word-count"
                  v-model="configForm.maxWordCount"
                  v-validate="{ numeric: true, min_value: 500, max_value: 32000 }"
                  placeholder="Default: 32000"
                  data-vv-name="max word count"
                  number
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <b-form-group
                id="input-group-number-of-words"
                label="Number of words"
                label-for="input-number-of-words"
                class="mb-4"
              >
                <b-form-input
                  id="input-number-of-words"
                  v-model="configForm.numberOfWords"
                  v-validate="{ numeric: true, min_value: 1 }"
                  placeholder="Default: 2"
                  data-vv-name="number of words"
                  number
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <b-form-group
                id="input-group-number-of-fields"
                label="Number of fields"
                label-for="input-number-of-fields"
                class="mb-4"
              >
                <b-form-input
                  id="input-number-of-fields"
                  v-model="configForm.numberOfFields"
                  v-validate="{ numeric: true, min_value: 10, max_value: 250 }"
                  placeholder="Default: 150"
                  data-vv-name="number of fields"
                  number
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="12" class="text-right">
                <b-btn variant="primary" size="lg" type="submit">
                  <i class="fa fa-plus" /> Save
                </b-btn>
            </b-col>

    </b-row>
  </b-form>
</template>

<script>
import $ from "jquery";
import Vue from "vue";
import { mapGetters } from "vuex";

export default {
  name: "ModelForm",
  props: {
    form: {
      type: Object,
      required: true
    },
    configForm: {
      type: Object,
      required: true
    },
    poolSelectionVisible: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      selectedPool: null,
      poolOptions: []
    };
  },

  computed: {
    ...mapGetters(["poolsByDateDesc"])
  },

  mounted() {
    this.popPoolOptions();
  },

  methods: {
    popPoolOptions() {
      let options = [
        {
          value: null,
          text: "Select Pool",
          disabled: true
        }
      ];
      options.push(
        ...this.poolsByDateDesc
          .filter(
            p => this.form.pools.findIndex(fp => fp.pool_id === p._id) < 0
          )

          .filter(
            //p => p.status.code === 4 && p.user_allowed.includes("Owner")
            p => p.status.label === "Done" && p.user_allowed.includes("Owner")
          )

          // This is used to filter pool type based on the pool you have selectedPool
          // Dropdown will only show pool types that match the selected pool type
          
          // .filter(
          //   p => {
          //     if(this.form.pools.length > 0){
          //       return p.dbtype === this.form.pools[0].type
          //     }
          //     else{
          //       return p
          //     }
          //   }
          // )

          .map(p => {
            return {
              value: p,
              text: p.name
            };
          })
      );
      this.poolOptions = options;
    },

    addPool() {
      this.form.pools.push({
        pool_id: this.selectedPool._id,
        documents: null,
        filter: null,
        type: this.selectedPool.dbtype
      });
      this.form.name = "Model for "+this.selectedPool.name;
      // this.popPoolOptions();

      Vue.nextTick(() => {
        $(".query")
          .last()
          .addClass("highlight");
      });
    },

    removePool(i) {
      this.form.pools.splice(i, 1);
      this.popPoolOptions();
    },
    
    submit() {
      if (this.poolSelectionVisible && this.form.pools.length === 0) {
        this.$toasted.show("Please add one or more pools", { type: "error" });
        return false;
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error"
          });
          return;
        }
        this.$emit("callback");
      });
    }
  }
};
</script>
